module.exports = __webpack_public_path__ + "static/orangeleaforganicmuslin-847fab78c087c89543ca424347821014.jpeg";